var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnKeyHistory = function SvgIAvnKeyHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.65 1.65h7M13.65 6.65h7M13.65 11.65h7",
    stroke: "#002774",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15 7.65a4.5 4.5 0 0 0-4.5 4.5h9a4.5 4.5 0 0 0-4.5-4.5Z",
    stroke: "#002774",
    strokeWidth: 1.3,
    "data-no-fill": "true"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.15,
    cy: 3.15,
    r: 2.5,
    stroke: "#002774",
    strokeWidth: 1.3,
    "data-no-fill": "true"
  })));
};
export { SvgIAvnKeyHistory as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjIgMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTMuNjUgMS42NTAwMkgyMC42NSIgc3Ryb2tlPSIjMDAyNzc0IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTEzLjY1IDYuNjUwMDJIMjAuNjUiIHN0cm9rZT0iIzAwMjc3NCIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxwYXRoIGQ9Ik0xMy42NSAxMS42NUgyMC42NSIgc3Ryb2tlPSIjMDAyNzc0IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTUuMTQ5OTkgNy42NTAwMkMyLjY2NDcxIDcuNjUwMDIgMC42NDk5OTQgOS42NjQ3NCAwLjY0OTk5NCAxMi4xNUg5LjY0OTk5QzkuNjQ5OTkgOS42NjQ3NCA3LjYzNTI4IDcuNjUwMDIgNS4xNDk5OSA3LjY1MDAyWiIgc3Ryb2tlPSIjMDAyNzc0IiBzdHJva2Utd2lkdGg9IjEuMyIgZGF0YS1uby1maWxsPSJ0cnVlIi8+CiAgICA8Y2lyY2xlIGN4PSI1LjE0OTk5IiBjeT0iMy4xNTAwMiIgcj0iMi41IiBzdHJva2U9IiMwMDI3NzQiIHN0cm9rZS13aWR0aD0iMS4zIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KPC9zdmc+";